import themeConfig from "@/asset/theme/index";
import { Theme } from "@/asset/theme/type";
import { ConfigProvider as PcConfigProvider } from "antd";
import {
  PropsWithChildren,
  createContext,
  useEffect,
  useRef,
  useState,
} from "react";

export const ThemeContext = createContext<Theme>({} as Theme);
ThemeContext.displayName = "PageCommonPropsa_ctx";

const ThemeVariableProvider = ({ children }: PropsWithChildren<{}>) => {
  const isMounted = useRef(false);

  const formatCssVarStr = (
    cssVars: Record<string, string>,
    prefix: string = "fanshub"
  ) => {
    let str = "";
    for (const key in cssVars) {
      if (Object.prototype.hasOwnProperty.call(cssVars, key)) {
        const value = cssVars[key];
        if (value) {
          str += `--${prefix}-${key
            .replace(/\B([A-Z])/g, "-$1")
            .toLowerCase()}: ${value};`;
        }
      }
    }
    return str;
  };

  const [customCssVarStr, setCustomCssVarStr] = useState("");
  const [admCssVarStr, setAdmCssVarStr] = useState("");

  useEffect(() => {
    isMounted.current = true;
    const theme = themeConfig;
    setCustomCssVarStr(formatCssVarStr(theme.cssVars));
    setAdmCssVarStr(formatCssVarStr(theme.admTheme, "adm"));
    PcConfigProvider.config({
      theme: theme.antdTheme,
    });
  }, []);

  return (
    <ThemeContext.Provider value={themeConfig}>
      {children}
      <style id="theme-var-provider">{`:root{${customCssVarStr}}`}</style>
      <style id="adm-theme-var-provider">{`:root:root{${admCssVarStr}}`}</style>
    </ThemeContext.Provider>
  );
};

export default ThemeVariableProvider;
